import { fetch } from "@/api/fetch-auto-refresh";
import { useStore } from "@/store";

export const getCaptainOptions = async (options = {}) => {
  const params = new URLSearchParams({
    page: 1,
    limit: 20,
    search: "",
    ...options
  });
  const response = await fetch(
    `${process.env.VUE_APP_API_URL}/v1/users/captain-options?${params}`,
    {
      headers: { Authorization: `Bearer ${useStore().state.auth.token}` }
    }
  );
  return response.json();
};
